import { useMutation } from "@tanstack/react-query";
import {
  createSegmentsAPI,
  deleteSegmentsAPI,
  updateSegmentsAPI,
} from "./segments.api";
import { handleNetworkError } from "@repo/ui/libs";

const useAddSegmentsMutation = () => {
  return useMutation({
    mutationFn: createSegmentsAPI,
    onError: handleNetworkError,
  });
};

const useUpdateSegmentsMutation = () => {
  return useMutation({
    mutationFn: updateSegmentsAPI,
    onError: handleNetworkError,
  });
};

const useDeleteSegmentsMutation = () => {
  return useMutation({
    mutationFn: deleteSegmentsAPI,
    onError: handleNetworkError,
  });
};

export {
  useAddSegmentsMutation,
  useUpdateSegmentsMutation,
  useDeleteSegmentsMutation,
};
